<div class="petcart-chat-view" style="min-height:600px; margin-top: 60px;">
  <div class="mt-channel-list-container">
    <div class="mt-live-channel-list-header">
      <div [ngClass]="getTabClasses('Started')" (click)="showTab('Started')"> On-Going </div>
      <div [ngClass]="getTabClasses('Scheduled')" (click)="showTab('Scheduled')"> Scheduled </div>
      <div [ngClass]="getTabClasses('Concluded')" (click)="showTab('Concluded')"> History </div>
    </div>

    <div class="mt-channel-list">
      <div *ngFor="let liveChannel of tabChannels | paginate: { itemsPerPage: 5, currentPage: p}"
        [ngClass]="getChannelClasses(liveChannel)"
        (click)="openLiveChannel(liveChannel)"
      >

        <div class="mt-live-channel-icon" *ngIf="userimgarray && userRole=='DOCTOR'">
            <img src="https://passport.petcart.in/images/userimgs/{{userimgarray['id'+liveChannel.customerExternalId]}}" alt="Avatar">
        </div>
        <div class="mt-live-channel-icon" *ngIf="userimgarray && userRole=='PATIENT'">
          <img src="https://passport.petcart.in/images/userimgs/{{userimgarray['id'+liveChannel.serviceProviderExternalId]}}" alt="Avatar">
      </div>

        <div class="mt-live-channel-content">
          <div class="mt-live-channel-content-top">
            <div class="mt-live-channel-title" *ngIf="usernamearray && userRole=='DOCTOR'">
                {{usernamearray['id'+liveChannel.customerExternalId]}}
            </div>
            <div class="mt-live-channel-title" *ngIf="usernamearray && userRole=='PATIENT'">
              {{usernamearray['id'+liveChannel.serviceProviderExternalId]}}
          </div>

            <div class="mt-live-channel-timeslot">
              {{formatDate(liveChannel.startTimeMs)}} - {{formatDate(liveChannel.endTimeMs)}}
            </div>
          </div>

          <div class="mt-live-channel-content-bottom">
            <div class="mt-live-channel-last-msg-content">
              {{liveChannel.lastMessage != null ? liveChannel.lastMessage.textPayload : "No messages"}}
            </div>

            <div *ngIf="mitterService.getUnreadMessagesCount(liveChannel.mitterChannelId) != 0" class="mt-live-channel-unread-count">
              {{mitterService.getUnreadMessagesCount(liveChannel.mitterChannelId)}}
            </div>

            <div class="mt-live-channel-last-msg-time">
              {{formatDate1(liveChannel.endTimeMs)}}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="tabChannels.length == 0" class="mt-live-channel-list-empty-message">
        No chats
      </div>
    </div>
    <div class="row" *ngIf="tabChannels.length > 0">
      <div class="col-12 text-right" style="font-size:18px ; color:#9b7544">
          <pagination-controls  (pageChange)="p = $event"></pagination-controls >
      </div>
    </div>
  </div>

  <div class="mt-channel-container" *ngIf="activeChannel; else emptyMessage">
    <mitter-channel [userRole]="userRole" [liveChannel]="activeLiveChannel"
      [channelId]="activeChannel" [mitter]="mitter">
    </mitter-channel>
  </div>

  <ng-template #emptyMessage>
    <div class="mt-channel-container">
      <div class="mt-no-channel-selected">
        Select a channel!
      </div>
    </div>
  </ng-template>
</div>
